export class Entity {
  constructor({id, registeredName, status, gdocsTerms, countryOfIncorporation}) {
    this.id = id;
    this.entityId = id;
    this.entityName = registeredName;
    this.caseId = undefined;
    this.status = status;
    this.gdocsTerms = gdocsTerms;
    this.cof = countryOfIncorporation;
  }
}

export class Case {
  constructor({entityId, entityName, id, caseId, status, owner, caseOwner, createdOn, statusKey}){
    this.id = id;
    this.entityId = entityId;
    this.entityName = entityName;
    this._caseId = caseId;
    this.caseId = id;
    this.status = status;
    this.statusKey = statusKey;
    this.owner = owner;
    this.caseOwner = caseOwner;
    this.createdOn = createdOn;
    this.doc = new Date();
    this.accounts = {};
    this.echannels = {};
    this.glsproducts = {};
  }
}



// WEBPACK FOOTER //
// ./src/utils/Models.js